import axios from 'axios';
import store from '../store';
import router from '../router/router';
import auth from './auth';
import division from './division';
import profile from './profile';
import brand from './brand';
import position from './position';
import entity from './entity';
import department from './department';
import house from './house';
import budget from './budget';
import taxonomy from './taxonomy';
import costGroup from './costGroup';
import productHierarchy from './productHierarchy';
import costCenter from './costCenter';
import costElement from './costElement';
import spending from './spending';
import stage from './stage';
import costCategory from './costCategory';
import costConsumer from './costConsumer';
import configuration from './configuration';
import dashboard from './dashboard';
import advanceFilter from './advanceFilter';
import purchasingOrder from './purchasingOrder';
import onePager from './onePager';
import budgetMovement from './budgetMovement';
import unit from './unit';
import keyHighlight from './keyHighlight';
import docs from './contentManagement/docs';
import notification from './notification';
import texts from './contentManagement/text';
import guidelineMenu from './contentManagement/menu';
import support from './contentManagement/support';
import mroi from './mroi';
import monthlyReport from './monthlyReport';
import auditTrail from './auditTrail';
import category from './category';
import contentPortal from './financialPortal/contentPortal';
import categoryPortal from './financialPortal/category';
import dynamic from './dynamic';
import approval from './dynamic/approval';
import spendingDynamic from './dynamic/spending';
import budgetDynamic from './dynamic/budget';
import channel from './channel';
import Swal from 'sweetalert2';
import investmetType from './investmentType';

export const TOKEN_NAME = 'app_token';
export const PROFILE = 'profile_id';
export const IV_NAME = 'iv';

const STORAGE_NAME = 'vuex';

export let host = process.env.VUE_APP_BASE_URL;
if (!process.env.API_URL) {
  host = process.env.VUE_APP_BASE_URL;
}

// export const SSHCFApi = axios.create({
//   baseURL: process.env.VUE_APP_SSHCF_BASE_URL
// });

// axios.defaults.baseURL = "http://149.129.241.35";
axios.defaults.baseURL = host;
axios.defaults.headers.post['Content-Type'] = 'application/json';
axios.defaults.headers.post['Accept'] = 'application/json';

// SSHCF Api
// SSHCFApi.defaults.headers.post['Content-Type'] = 'application/json';
// SSHCFApi.defaults.headers.post['Accept'] = 'application/json';

// // axios interceptors refresh token
// axios.interceptors.request.use(function (config) {
//   // Do something before request is sent
//   return config;
// }, function (error) {
//   // Do something with request error
//   return Promise.reject(error);
// });

axios.interceptors.response.use(
  response => {
    if (response.status === 401) {
      store.dispatch('auth/logout');
      router.push({
        path: '/login',
        params: {
          error: 401
        }
      });
      Swal.fire('Failed!', response.data.message.text_en, 'error');
    }
    return response;
  },
  error => {
    if (error.response.status === 401) {
      store.dispatch('auth/logout');
      router.push({
        path: '/login',
        params: {
          error: 401
        }
      });
      Swal.fire('Failed!', error.response.data.message.text_en, 'error');
      return Promise.reject(error.response.data);
    }
    return Promise.reject(error);
  }
);

// call this method to set axios authorization header
export const setAccessToken = token => {
  axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
  // SSHCFApi.defaults.headers.common['Authorization'] = 'Bearer ' + token;
};

export const setProfile = token => {
  axios.defaults.headers.common['profile_id'] = token;
  // SSHCFApi.defaults.headers.common['profile_id'] = token;
};
export const setIv = token => {
  axios.defaults.headers.common['iv'] = token;
};

export function getVuexStorage() {
  const ls = localStorage[STORAGE_NAME];
  if (!ls) return {};
  return JSON.parse(ls);
}

export function getAccessToken() {
  return localStorage.getItem(TOKEN_NAME);
}

export function getProfile_id() {
  return localStorage.getItem(PROFILE);
}
export function getIv() {
  return localStorage.getItem(IV_NAME);
}

if (localStorage.getItem(TOKEN_NAME) !== null) {
  const token = localStorage.getItem(TOKEN_NAME);
  setAccessToken(token);
  const profiles = localStorage.getItem(PROFILE);
  setProfile(profiles);
  const iv = localStorage.getItem(IV_NAME);
  setIv(iv);
}

if (getAccessToken() !== null) {
  setAccessToken(getAccessToken());
}
if (getProfile_id() !== null) {
  setProfile(getProfile_id());
}
if (getIv() !== null) {
  setIv(getIv());
}
// axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";
// axios.defaults.withCredentials = false;
// axios.defaults.headers.post["Access-Control-Allow-Methods"] = "GET, PUT, POST, PATCH, DELETE, OPTIONS";
// axios.defaults.headers.post["Access-Control-Allow-Headers"] = "Content-Type, Authorization";
// axios.defaults.headers.post["Content-Type"] = "application/json";

export default {
  auth,
  division,
  profile,
  brand,
  position,
  entity,
  department,
  house,
  budget,
  taxonomy,
  costGroup,
  productHierarchy,
  costCenter,
  costElement,
  spending,
  stage,
  costCategory,
  costConsumer,
  configuration,
  dashboard,
  advanceFilter,
  purchasingOrder,
  onePager,
  budgetMovement,
  unit,
  keyHighlight,
  docs,
  notification,
  texts,
  guidelineMenu,
  mroi,
  monthlyReport,
  auditTrail,
  support,
  category,
  contentPortal,
  categoryPortal,
  dynamic,
  approval,
  spendingDynamic,
  budgetDynamic,
  channel,
  investmetType
};
